module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--live-759d8e23525bf1253188e8ea315ace15.png";